import {
    WithStyles,
    withStyles,
} from "@material-ui/core";
import cx from 'classnames';
import React, { Component } from "react";
import { connect } from "react-redux";
import { questionCardStyle } from "../styles/questionCardStyle";
import getDefaultFormData from '../../mylibrary/types/ContentFromDataDefault'
import contentService from '../../mylibrary/services/contentService';
import MyPATQuestionBar from "../../common/MyPATQuestionBar";
import { bindActionCreators } from "redux";
import _ from 'lodash';
import { contentRequestAccordianActions } from "../reducers/contentRequestAccordianState";
import contentRequestService from '../services/contentRequestServices';

interface TestCardProps extends WithStyles<typeof questionCardStyle> {
    count: number,
    code: string,
    requestId: string,
    handleTestState: Function,
    history: any,
    contentRequestItemsId: any,
    handleChooseFromLibrary: Function
    attachedQuestions: any,
    handleReset: Function,
    progressBar: any,
    setProgressBar: Function,
    contentRequestId: string,
    type: string,
    isTestRequest: boolean,
    testDetails: any,
    handleSaveTest: Function,
    handleResetTest: Function,
    setContentRequestItemsIdForFirstTime: Function,
    setProgressBarForTest: Function,
    progressBarForTest: any;
    accordianTest: any;
    handleResetTestForUnresolvedFeedbackCount: Function;
    handleSaveTestForUnresolvedCount: Function;
    setTestAccordian: Function
}

interface TestCardState {

}

class TestCard extends Component<TestCardProps, TestCardState> {
    constructor(props: TestCardProps) {
        super(props);
        this.state = {
        };
    }

    handleSaveTestForUnresolvedCount = (res: any, index: number) => {
        const { setTestAccordian, accordianTest } = this.props;
        const { contentId, _id } = res.responseObject;
        let cloneAccordianTest = JSON.parse(JSON.stringify(accordianTest))
        cloneAccordianTest[0].testContent[index-1].attachedQuestions = {
            ...cloneAccordianTest[0].testContent[index-1].attachedQuestions,
            contentId,
            content_Id: _id,
            previousVersion: {
                ...cloneAccordianTest[0].testContent[index-1].attachedQuestions.previousVersion
            }
        }
        setTestAccordian(cloneAccordianTest);
    }
    handleCreate = (type: string, index: number, testDetails: any, unresolvedFeedbackCount?: number) => {
        const defaultFromData = getDefaultFormData();
        defaultFromData.settings.testType = type;
        const { requestId = '', handleTestState, contentRequestId, setContentRequestItemsIdForFirstTime } = this.props;
        handleTestState();
        contentService.save('', 'testpapers', defaultFromData, false)
            .then((res: any) => {
                if (!testDetails.contentRequestItemsId) {
                    const reqBody = {
                        contents: [
                            {
                                sequenceNo: index,
                                content_id: res.responseObject._id
                            }
                        ],
                        type: 'test',
                        contentRequestId
                    }
                    contentRequestService.createQuestionForPostContentRequest({ ...reqBody }).then((response: any) => {
                        if (response) {
                            const { contentRequestItem: { _id = '' } = {} } = response;
                            setContentRequestItemsIdForFirstTime({ id: _id });
                            window.open(
                                `${window.location.origin.toString()}/content/edit/testpapers/${type}/${res.responseObject._id}testpapers/${requestId}`, "_blank");
                                if (!unresolvedFeedbackCount) {
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 2500)
                                }
                        }
                    });
                } else {
                    if (unresolvedFeedbackCount) {
                        this.handleSaveTestForUnresolvedCount(res,index);                        window.open(
                            `${window.location.origin.toString()}/content/edit/testpapers/${type}/${res.responseObject._id}testpapers/${requestId}`, "_blank");

                    } else {
                        const { _id } = testDetails.contentRequestItemsId;
                        const reqBody = {
                            contents: [{
                                sequenceNo: index,
                                contentId: res.responseObject._id
                            }]
                        };

                        contentRequestService.createQuestionForPutContentRequest(_id, { ...reqBody }).then((response: any) => {

                            window.open(
                                `${window.location.origin.toString()}/content/edit/testpapers/${type}/${res.responseObject._id}testpapers/${requestId}`, "_blank");
                        });
                    }
                    if (!unresolvedFeedbackCount) {
                        setTimeout(() => {
                            window.location.reload();
                        }, 2500)
                    }
                }
                
            })
    }

    render = () => {
        const { count = 0, code = '', handleReset, attachedQuestions, progressBar, setProgressBar, type, isTestRequest, contentRequestItemsId, testDetails, handleSaveTest, contentRequestId, handleResetTest,requestId } = this.props;
        const { contentId = '', content_Id = '', isJobCompleted = false } = attachedQuestions;
        let saveReset = false;
        let importCreate = false;
        contentId && content_Id ? saveReset = true : importCreate = true;
        return (
            <>
                <MyPATQuestionBar
                    requestId={requestId}
                    importCreate={importCreate}
                    saveReset={saveReset}
                    contentId={contentId}
                    content_Id={content_Id}
                    count={count}
                    progressBar={progressBar}
                    setProgressBar={setProgressBar}
                    handleCreate={() => { this.handleCreate(type, count, testDetails, attachedQuestions.unresolvedFeedbackCount) }}
                    handleReset={handleResetTest}
                    handleResetQuestionForUnresolvedCount={this.props.handleResetTestForUnresolvedFeedbackCount}
                    isTestRequest={isTestRequest}
                    handleSaveTest={handleSaveTest}
                    testDetails={testDetails}
                    progressBarForTest={this.props.progressBarForTest}
                    setProgressBarForTest={this.props.setProgressBarForTest}
                    contentRequestId={contentRequestId}
                    isJobCompleted={isJobCompleted}
                    urlRequestType='testpapers'
                    previousVersion={attachedQuestions.previousVersion}
                    newVersion={attachedQuestions}
                    unresolvedFeedbackCount={attachedQuestions.unresolvedFeedbackCount}
                    handleSaveTestForUnresolvedCount={this.props.handleSaveTestForUnresolvedCount}
                />

            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    const { contentRequestData = {} } = state;
    localStorage.setItem('allStates', JSON.stringify({ contentRequestData }));
    return {
        progressBar: _.get(state, 'contentRequestData.contentRequestAccordianData.progressBar', {}),
        contentRequestItemsIdForFirstTime: _.get(state, 'contentRequestData.contentRequestAccordianData.contentRequestItemsIdForFirstTime', {}),
        progressBarForTest: _.get(state, 'contentRequestData.contentRequestAccordianData.progressBarForTest', {}),
        accordianTest: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTest', []),
    }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    setProgressBarForTest: contentRequestAccordianActions.setProgressBarForTest,
    setContentRequestItemsIdForFirstTime: contentRequestAccordianActions.setContentRequestItemsIdForFirstTime,
    setTestAccordian: contentRequestAccordianActions.setTestAccordian,

}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
)(withStyles(questionCardStyle)(TestCard));